import * as type from '../actions/types';
const initialState = {
    hiredProjects: [],
    offset: 0,
    loading: false,
    error: null,
}
export default function hiredProjectsData(state = initialState, action) {
    switch (action.type) {
        case type.GET_ALL_HIRED_REQUESTED:
            return {
                ...state,
                loading: true,
            }
        case type.GET_ALL_HIRED_SUCCESS:
            return {
                ...state,
                loading: false,
                hiredProjects: action.data.projects,
                offset: 0,
            }
        case type.GET_ALL_HIRED_FAILED:
            return {
                ...state,
                loading: false,
                error: action.message,
            }
        default:
            return state
    }
}